<template lang="pug">
div
  .vip-button-new-container(:class='classes' v-if="true")
    .trial-title - 续费正式版 -
    .trans-tab
      .trans-left(v-if="!isOne" @click="buy(1,false)")
        .trans-left-one
          span 续费1个月
          span.red-sign ¥
          span.red-money {{info.price>=0?info.price:'-'}}
        .trans-left-two 日常价¥{{info.markedPrice*1||'-'}}
      .trans-left-oneMouth(v-else @click="buy(null,false)")
        .trans-left-one
          span 续费1个月
          span.sign ¥
          span.big-money {{info.price*1}}
        .trans-left-two 日常价¥{{info.markedPrice*1||'-'}}
      .trans-right(v-if="!isOne" @click="buy(null,true)")
        .trans-right-one
          span 连续包月
          span.sign ¥
          span.big-money {{info.signInfoDTO?info.signInfoDTO.firstSignPrice:'-'}}
        .trans-right-two 次月起 {{info.signInfoDTO?info.signInfoDTO.secondSignPrice:'-'}}/月续费
      .trans-right-oneMouth(v-else @click="buy(1,true)")
        .trans-right-one
          span 连续包月
          span.red-sign ¥
          span.red-money {{info.signInfoDTO?info.signInfoDTO.firstSignPrice:'-'}}
        .trans-right-two 次月起 {{info.signInfoDTO?info.signInfoDTO.secondSignPrice:'-'}}/月续费
    .renewal-rules
      div(style="display:flex")
        span.normal 购买即同意
        span.canClick(@click="goMember") 《哈啰会员服务协议》
        span.normal 与
        span.canClick(@click="goRenewal")  《自动续费协议》
  </template>
<script>
import Picture from '@/components/picture';
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { commonGoLink } from '@/utils';
import eventBus from '@/const/eventBus.js';
import Toast from '@/components/toast';
import TransTab from './transTab.vue';
import { getSource } from '../../../../utils';

export default {
  components: {
    Lottie,
    Picture,
    TransTab,
  },
  props: {
    info: {
      type: Object,
      default: null,
    },
    readSign: {
      type: Boolean,
      default: false,
    },
    isIndex: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      classes: {
        show: false,
        fixed: false,
      },
      loadingPay: false,
      env,
      timer: null,
      timeout: null,
      allMonth: true,
      isNoSign: true,
      isOne: false,
    };
  },
  computed: {
    openPrice() {
      if (this.allMonth) {
        // eslint-disable-next-line no-nested-ternary
        return this.info.signInfoDTO ? (this.info.signInfoDTO.firstSignPrice >= 0 ? this.info.signInfoDTO.firstSignPrice : '-') : '-';
      }
      return (this.info.price >= 0) ? this.info.price : '-';
    },
  },
  watch: {
    readSign(val) {
      this.isNoSign = !val;
      eventBus.$emit('isNoSign', this.isNoSign);
    },
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_opencard_button',
      contentId: 'platform_opencard_button',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
  },
  mounted() {
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  methods: {
    buy(val, bool) {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_VIPnewpay',
        categoryId: 'platform',
        businessInfo: {},
      });
      // this.isNoSign = false;
      if (val) {
        this.isOne = !this.isOne;
      }
      if (bool) {
        this.allMonth = true;
      } else {
        this.allMonth = false;
      }
      if (this.openPrice >= 0 && this.openPrice !== '-') {
        this.$emit('transTab', this.allMonth ? 30 : 20, this.openPrice);
        this.open();
      } else {
        Toast.show('暂无数据');
      }
    },
    open() {
      let ubtType;
      if (this.allMonth === 30) {
        ubtType = 2;
      } else {
        ubtType = 1;
      }
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_type_choose',
        categoryId: 'platform',
        businessInfo: {
          type: ubtType,
          typeandprice: `1&${this.info.signInfoDTO.firstSignPrice};2&${this.info.current}`,
        },
      });
      if (this.info.showPopUpWindowType !== 1) {
        this.$emit('open', null, this.allMonth ? 30 : 20, this.openPrice, this.info.goodsGuid);
      } else {
        this.$emit('openDialog');
      }
    },
    goRenewal() {
      commonGoLink(
        'https://m.hellobike.com/mf/spa/u_hywaxn/latest/MA2209193493443248207695231.html?activityCode=MA2209193493443248207695231',
        { isRuleLink: true },
      );
    },
    goMember() {
      commonGoLink(
        'https://m.hellobike.com/mf/spa/u_yewmjx/latest/MA2209283520078470713971794.html?activityCode=MA2209283520078470713971794',
        { isRuleLink: true },
      );
    },
    // 确定组件是否要固定在底部
    locate() {
      this.classes.fixed = true;
      this.classes.show = true;
    },
  },
};
</script>
<style lang="less" scoped>
.vip-button-new-container {
  background: #fff;
  box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
  z-index: 3;
  padding: 0.08rem 0.2rem 0.34rem 0.2rem;
  height: 1.39rem;
  width: 100%;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  position: fixed;
  bottom: 0;

  &.show {
    opacity: 1;
  }

  &.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.25);
    border-radius: 0.12rem 0.12rem 0 0;
  }

  .trial-title {
    font-size: 0.12rem;
    font-weight: 400;
    line-height: 16.8px;
    text-align: center;
    margin-bottom: 0.08rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    color: #373e3b;
  }

  .trans-tab {
    display: flex;

    .trans-left {
      width: 1.45rem;
      height: 0.52rem;
      background: url(https://m.hellobike.com/resource/helloyun/08345/Bc3USEn9fr.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      border-radius: 0.26rem;
      margin-right: 0.15rem;
      text-align: center;

      .trans-left-one {
        margin-top: 0.06rem;
        font-family: PingFangSC-Medium, sans-serif;
        font-size: 0.14rem;
        color: #242729;
        font-weight: 500;

        .red-sign {
          font-family: DINAlternate-Bold, sans-serif;
          font-size: 0.14rem;
          color: #fa2a00;
          text-align: center;
          font-weight: 700;
          margin-right: 0.02rem;
        }

        .red-money {
          font-family: DINAlternate-Bold, sans-serif;
          font-size: 0.24rem;
          color: #fa2a00;
          text-align: center;
          line-height: 0.24rem;
          font-weight: 700;
        }
      }

      .trans-left-two {
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.12rem;
        color: #879099;
        line-height: 0.12rem;
        font-weight: 400;
        text-decoration: line-through;
      }
    }

    .trans-left-oneMouth {
      background-image: linear-gradient(90deg, #fa3a00 0%, #fa8621 100%);
      box-shadow: inset 0 0.01rem 0.03rem 0 rgba(252, 122, 94, 1);
      border-radius: 0.26rem;
      width: 1.75rem;
      height: 0.52rem;
      text-align: center;

      .trans-left-one {
        margin-top: 0.06rem;
        font-family: PingFangSC-Semibold, sans-serif;
        font-size: 0.14rem;
        color: #fff;
        line-height: 0.2rem;
        font-weight: 600;

        .sign {
          font-family: DINAlternate-Bold, sans-serif;
          font-size: 0.14rem;
          color: #fff;
          line-height: 0.2rem;
          font-weight: 700;
          margin-right: 0.02rem;
        }

        .big-money {
          font-size: 0.24rem;
          line-height: 0.24rem;
          font-family: DINAlternate-Bold, sans-serif;
        }
      }

      .trans-left-two {
        opacity: 0.7;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.12rem;
        color: #fff;
        font-weight: 400;
        text-decoration: line-through;
      }
    }

    .trans-right-oneMouth {
      width: 1.45rem;
      height: 0.52rem;
      background: url(https://m.hellobike.com/resource/helloyun/08345/Bc3USEn9fr.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      border-radius: 0.26rem;
      margin-left: 0.15rem;
      text-align: center;

      .trans-right-one {
        margin-top: 0.06rem;
        font-family: PingFangSC-Medium, sans-serif;
        font-size: 0.14rem;
        color: #242729;
        font-weight: 500;

        .red-sign {
          font-family: DINAlternate-Bold, sans-serif;
          font-size: 0.14rem;
          color: #fa2a00;
          text-align: center;
          font-weight: 700;
          margin-right: 0.02rem;
        }

        .red-money {
          font-family: DINAlternate-Bold, sans-serif;
          font-size: 0.24rem;
          color: #fa2a00;
          text-align: center;
          line-height: 0.24rem;
          font-weight: 700;
        }
      }

      .trans-right-two {
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.12rem;
        color: #879099;
        line-height: 0.12rem;
        font-weight: 400;
      }
    }

    .trans-right {
      background-image: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      box-shadow: inset 0 0.01rem 0.03rem 0 rgba(252, 122, 94, 1);
      border-radius: 0.26rem;
      width: 1.75rem;
      height: 0.52rem;
      text-align: center;
      position: relative;

      .hand {
        position: absolute;
        top: -0.08rem;
        left: -0.04rem;
        width: 2rem;
        height: 1rem;
        z-index: 1;
      }

      .trans-right-one {
        margin-top: 0.06rem;
        font-family: PingFangSC-Medium, sans-serif;
        font-size: 0.14rem;
        color: #fff;
        line-height: 0.2rem;
        font-weight: 500;

        .sign {
          font-family: DINAlternate-Bold, sans-serif;
          font-size: 0.14rem;
          color: #fff;
          line-height: 0.2rem;
          font-weight: 700;
          margin-right: 0.02rem;
        }

        .big-money {
          font-size: 0.24rem;
          line-height: 0.24rem;
          font-family: DINAlternate-Bold, sans-serif;
        }
      }

      .trans-right-two {
        opacity: 0.7;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.12rem;
        color: #fff;
        font-weight: 400;
      }
    }
  }

  .renewal-rules {
    margin-top: 0.2rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    color: #879099;
    text-align: center;
    display: flex;
    justify-content: center;
    z-index: 99;

    .canClick {
      color: #b16652;
      z-index: 99;
    }

    img.rule-word-img {
      margin-right: 0.05rem;
      width: 0.16rem;
      height: 0.16rem;
    }
  }
}

.vip-button-no {
  background: #fff;
  box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
  border-radius: 0.2rem 0.2rem 0 0;
  z-index: 3;
  padding: 0.16rem 0.2rem 0.34rem 0.2rem;
  height: 1.41rem;
  width: 100%;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  position: fixed;
  bottom: 0;

  .vip-button-img {
    margin-bottom: 0.14rem;
    display: flex;
    justify-content: center;

    img {
      width: 3.75rem;
      height: 0.26rem;
    }
  }

  .vip-button-block {
    display: flex;
    justify-content: space-between;

    .vip-left-button {
      background: #eef2f5;
      border: 0.005rem solid #e4e8eb;
      border-radius: 0.26rem;
      width: 1.45rem;
      height: 0.52rem;
      text-align: center;
      color: #879099;

      .trans-left-one {
        margin-top: 0.06rem;
        font-family: PingFangSC-Semibold, sans-serif;
        font-size: 0.14rem;
        line-height: 0.2rem;
        font-weight: 600;

        .sign {
          font-family: DINAlternate-Bold, sans-serif;
          font-size: 0.14rem;
          line-height: 0.2rem;
          font-weight: 700;
          margin-right: 0.02rem;
        }

        .big-money {
          font-size: 0.24rem;
          line-height: 0.24rem;
          font-family: DINAlternate-Bold, sans-serif;
        }
      }

      .trans-left-two {
        opacity: 0.7;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        text-decoration: line-through;
      }
    }

    .vip-right-button {
      background: #bcc4cc;
      border-radius: 0.26rem;
      width: 1.75rem;
      height: 0.52rem;
      text-align: center;
      position: relative;

      .trans-right-one {
        margin-top: 0.06rem;
        font-family: PingFangSC-Medium, sans-serif;
        font-size: 0.14rem;
        color: #fff;
        line-height: 0.2rem;
        font-weight: 500;

        .sign {
          font-family: DINAlternate-Bold, sans-serif;
          font-size: 0.14rem;
          color: #fff;
          line-height: 0.2rem;
          font-weight: 700;
          margin-right: 0.02rem;
        }

        .big-money {
          font-size: 0.24rem;
          line-height: 0.24rem;
          font-family: DINAlternate-Bold, sans-serif;
        }
      }

      .trans-right-two {
        opacity: 0.7;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.12rem;
        color: #fff;
        font-weight: 400;
      }
    }
  }
}
</style>
